import { getBroccoliHarvestOptimiserSupabase } from "../../../consts/supabaseClient.js";

const CONFIG_RECORD_TABLE = "Config Record";
const ACTUAL_YIELD_TABLE = "Actual Yield Table";
const SITE_CONFIG_TABLE = "Site Config";

export async function fetchSiteConfig(siteId) {
  const supabase = getBroccoliHarvestOptimiserSupabase();
  const { data, error } = await supabase
    .from(SITE_CONFIG_TABLE)
    .select("*")
    .eq("site", siteId)
    .limit(1);

  if (error) {
    console.error("Error fetching Site Config:", error);
    return null;
  }

  return data?.[0] ?? null;
}

export async function fetchConfigRecords(siteId) {
  const supabase = getBroccoliHarvestOptimiserSupabase();
  const { data, error } = await supabase
    .from(CONFIG_RECORD_TABLE)
    .select("*")
    .eq("site", siteId);

  if (error) {
    console.error("Error fetching Config Record:", error);
    return [];
  }

  return data;
}

export async function fetchActualYields(siteId) {
  const supabase = getBroccoliHarvestOptimiserSupabase();
  const { data, error } = await supabase
    .from(ACTUAL_YIELD_TABLE)
    .select("*")
    .eq("site", siteId);

  if (error) {
    console.error("Error fetching Actual Yield Table:", error);
    return [];
  }

  return data;
}

export async function upsertActualYields(rows) {
  const supabase = getBroccoliHarvestOptimiserSupabase();
  const convertedRows = rows.map((row) => ({
    ...row,
    actual_yield: row.actual_yield != null ? row.actual_yield * 1000 : null,
  }));
  const { data, error } = await supabase
    .from(ACTUAL_YIELD_TABLE)
    .upsert(convertedRows, { onConflict: "id" })
    .select();

  if (error) throw error;
  return data;
}

export async function updateConfigRecordYields(updates) {
  /**
   * Updates Config Record table with harvested_stand_count values.
   * updates = [{ site, paddock, block, harvested_stand_count }, ...]
   *
   * Silently logs errors — does not throw, allowing yield saves to succeed even if Config update fails.
   */
  try {
    const supabase = getBroccoliHarvestOptimiserSupabase();
    for (const update of updates) {
      const { error } = await supabase
        .from(CONFIG_RECORD_TABLE)
        .update({ harvested_stand_count: update.harvested_stand_count })
        .eq("site", update.site)
        .eq("paddock", update.paddock)
        .eq("block", update.block);

      if (error) {
        console.error(
          `Failed to update Config Record for ${update.site}/${update.paddock}/${update.block}:`,
          error
        );
      }
    }
  } catch (err) {
    console.error("Error updating Config Records:", err);
  }
}
